import React, { useEffect, useState } from "react";
import {connect} from "react-redux";

import "./AuditList.css";
import { useTranslation } from 'react-i18next';
import { IApplicationState } from "src/~store/models/ApplicationState";
import { auditOperatorsSelector, auditTagsSelector, auditsSelector, isReceivingAuditsSelector } from "../../~store/selector";
import { getAllOperators, getAuditsByTags, saveAuditTags } from "../../~store/actions/actions";
import { IAuditListProps } from "./~types/AuditListProps";
import { AuditItem } from "./audit-item/AuditItem";
import TagSearchingInput from "src/app/shared/components/tag-searching-input/TagSearchingInput";
import { getAuditSearchingTags } from "../../~store/constants/AuditConstants";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { AuditItemInfo } from "./audit-item/audit-item-info/AuditItemInfo";
import { IAudit } from "../../~store/models/Audit";

type ReduxType = ReturnType<typeof mapStateToProps> & IAuditListProps;

const AuditList = (props: ReduxType) => {
    const { t } = useTranslation();

    const [selectedAudit, setSelectedAudit] = useState<IAudit|undefined>(undefined)

    useEffect(() => {props.getAllOperators()}, [])

    useEffect(() => {
        props.getAuditsByTags(0);
    }, [props.auditTags]);

    const onAuditScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
        if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight <= 10) {      
            props.getAuditsByTags(props.audits.length);
        }
    }

    const _getOperatorInfo = (id: number): string => {
        if(id === 0) return "Admin";
        const operator = props.operators.find(o => o.operatorId === id);

        if(operator) {
            return operator.login;
        }

        return "Operator-" + id;
    }

    const _onClick = (audit: IAudit) => {
        setSelectedAudit(audit);
    }

    return (
        <div className="audit-list-container">
            <TagSearchingInput
                searchingTags={getAuditSearchingTags()}
                operators={props.operators}
                onSearch={(tags) => props.saveAuditTags(tags)}
                repeatingTags={false}
                currentTags={props.auditTags || []}
                onClearFilter={() => props.saveAuditTags([])}
            />
            {selectedAudit && <AuditItemInfo audit={selectedAudit} operatorName={_getOperatorInfo(selectedAudit.operatorId)} onClose={() => setSelectedAudit(undefined)}/>}
            <div onScroll={onAuditScroll} className="audit-list">
                <table className="card-table">
                    <thead>
                        <tr className="audit-list-header">
                            <th className="col-badge"></th>
                            <th className="col-id">{t('common.id')}</th>
                            <th className="col-date">{t('common.date')}</th>
                            <th className="col-operator">{t('common.operator')}</th>
                            <th className="col-type">{t("common.type")}</th>
                            <th className="col-data">{t("common.data")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.audits.map(a => {
                            return (
                                <AuditItem onClick={_onClick} key={a.auditId} audit={a} operatorName={_getOperatorInfo(a.operatorId)}/>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        audits: auditsSelector(state),
        isAuditsRecieving: isReceivingAuditsSelector(state),
        auditTags: auditTagsSelector(state),
        operators: auditOperatorsSelector(state)
    };
};

const mapDispatchToProps = (dispatch: any): IAuditListProps => {
    return {
        getAuditsByTags:(skip: number) => dispatch(getAuditsByTags(skip)),
        saveAuditTags:(tags: ISearchingTag[]) => dispatch(saveAuditTags(tags)),
        getAllOperators:() => dispatch(getAllOperators())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditList);
